import React from 'react';
import { Input, Props as InputProps } from './Input';
import { Box, IconButton, InputLabel, SxProps } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Switch } from 'components/Switch';

const container: SxProps = {
  display: 'flex',
  alignItems: 'center',
  width: '100%'
};

type Props = {
  onRemoveClick: () => void;
  onMandatoryToggled: (checked: boolean) => void;
  hideRemoveIcon?: boolean;
  hideCheckbox?: boolean;
  isMandatory?: boolean;
} & InputProps;

const actionItemHeight = 60;

export const InputControls = ({
  onRemoveClick,
  onMandatoryToggled,
  hideRemoveIcon,
  hideCheckbox,
  isMandatory
}: {
  onRemoveClick: () => void;
  onMandatoryToggled?: (checked: boolean) => void;
  hideRemoveIcon?: boolean;
  isMandatory?: boolean;
  hideCheckbox?: boolean;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: -3,
        ml: 2,
        width: 300
      }}
    >
      {!hideCheckbox && (
        <Box height={actionItemHeight}>
          <Switch
            onToggle={
              onMandatoryToggled ||
              (() => {
                //
              })
            }
            isInitiallyChecked={isMandatory}
            label="Mandatory"
          />
        </Box>
      )}
      {!hideRemoveIcon && (
        <Box height={actionItemHeight} sx={{ marginLeft: 1 }}>
          <InputLabel sx={{ marginBottom: 1 }}>Remove</InputLabel>
          <IconButton onClick={onRemoveClick} sx={{ color: 'primary.main' }}>
            <HighlightOffIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export const InputWithControls: React.FC<Props> = ({
  onRemoveClick,
  onMandatoryToggled,
  hideRemoveIcon,
  isMandatory,
  ...restInputProps
}) => {
  return (
    <Box sx={container}>
      <Input {...restInputProps} />
      <InputControls
        onRemoveClick={onRemoveClick}
        onMandatoryToggled={onMandatoryToggled}
        hideRemoveIcon={hideRemoveIcon}
        isMandatory={isMandatory}
      />
    </Box>
  );
};
